"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var colors_1 = require("../colors");

var themes_1 = require("../themes");

exports.Twitter = function (props) {
  var _a;

  return react_1.default.createElement("svg", __assign({}, props, {
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48
  }), react_1.default.createElement("defs", null, react_1.default.createElement("path", {
    fill: (_a = colors_1.getColor(props), _a !== null && _a !== void 0 ? _a : themes_1.defaultTheme.colors.default.onColor),
    id: "i-1207",
    d: "M41.497,15.149c0.019,0.387,0.025,0.773,0.025,1.164c0,11.93-9.079,25.684-25.684,25.684c-5.101,0-9.843-1.492-13.839-4.057 c0.709,0.086,1.427,0.125,2.154,0.125c4.232,0,8.121-1.439,11.209-3.863c-3.947-0.068-7.283-2.676-8.431-6.266 c0.552,0.111,1.116,0.16,1.696,0.16c0.826,0,1.624-0.105,2.379-0.314c-4.125-0.828-7.24-4.481-7.24-8.852c0-0.039,0-0.076,0-0.113 c1.219,0.676,2.609,1.084,4.088,1.127c-2.421-1.615-4.014-4.383-4.014-7.514c0-1.654,0.447-3.201,1.221-4.539 c4.451,5.463,11.107,9.057,18.605,9.432c-0.15-0.66-0.232-1.348-0.232-2.057c0-4.984,4.042-9.023,9.029-9.023 c2.594,0,4.941,1.096,6.586,2.848c2.057-0.404,3.99-1.156,5.736-2.188c-0.678,2.105-2.105,3.879-3.971,4.99 c1.826-0.215,3.566-0.697,5.184-1.418C44.791,12.286,43.262,13.875,41.497,15.149z"
  })), react_1.default.createElement("use", {
    x: 0,
    y: 0,
    xlinkHref: "#i-1207"
  }));
};